<template>
  <v-row>
    <v-col cols="12" v-if="selectedProfile == null">
      <v-row justify="end">
        <v-btn class="ma-2" @click="addProfile" color="success" small dark>
          create new profile
          <v-icon right dark>add</v-icon>
        </v-btn>
        <v-btn class="ma-2" @click="importProfile" color="success" small dark>
          import profile
          <v-icon right dark>cloud_upload</v-icon>
        </v-btn>
      </v-row>
    </v-col>
    <v-col cols="12" v-if="!profiles || !profiles.length">
      <v-alert :value="true" type="warning">No profiles configured!</v-alert>
    </v-col>
    <v-col cols="12" v-if="!selectedProfile && profiles">
      <v-container class="grid-list" fluid>
        <v-row>
          <v-col
            class="d-flex child-flex"
            v-for="profile in profiles"
            :key="profile.id"
            cols="12"
            sm="6"
            md="4"
          >
            <v-card class="flexcard" style="display:flex;flex-direction:column;" height="100%">
              <v-card-title>
                <span class="title font-weight-light">{{profile.name}}</span>
              </v-card-title>
              <v-card-text class="grow">{{profile.description}}</v-card-text>
              <v-card-actions>
                <v-row align="end" justify="end">
                  <v-btn class="ma-2" icon @click="selectedProfile = profile">
                    <v-icon color="primary">edit</v-icon>
                  </v-btn>
                  <v-btn class="ma-2" icon @click="exportProfile(profile.id)">
                    <v-icon color="primary">cloud_download</v-icon>
                  </v-btn>
                  <v-btn class="ma-2" icon @click="removeProfile(profile.id)">
                    <v-icon color="error">delete</v-icon>
                  </v-btn>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-col>
    <v-col cols="12" lg="6">
      <organizationProfileForm
        v-if="selectedProfile != null"
        :me="me"
        :profile="selectedProfile"
        v-on:done="selectedProfile = null"
        v-on:reset="getProfiles"
      ></organizationProfileForm>
    </v-col>
  </v-row>
</template>

<script>
import organizationProfileForm from "../../components/OrganizationProfileForm.vue";
export default {
  name: "OrganizationProfile",
  props: ["me"],
  components: {
    organizationProfileForm
  },
  data() {
    return {
      selectedProfile: null,
      profiles: []
    };
  },
  methods: {
    parseUploadedProfile(val) {
      delete val.id;
      delete val.created;
      delete val.modified;
      delete val.modifiedBy;
      delete val.modifiedById;
      delete val.order;
      if (val.fields) {
        val.fields.forEach(f => {
          delete f.id;
          delete f.created;
          delete f.modified;
          delete f.modifiedBy;
          delete f.modifiedById;
          delete f.order;
          delete f.profileId;
        });
      }
      if (val.apiKeys) {
        val.apiKeys.forEach(a => {
          delete a.id;
          delete a.created;
          delete a.modified;
          delete a.modifiedBy;
          delete a.modifiedById;
          delete a.profileId;
        });
      }
      if (val.triggers) {
        val.triggers.forEach(t => {
          delete t.id;
          delete t.created;
          delete t.modified;
          delete t.modifiedBy;
          delete t.modifiedById;
          delete t.order;
          delete t.profileId;
          if (t.actions) {
            t.actions.forEach(a => {
              delete a.id;
              delete a.created;
              delete a.modified;
              delete a.modifiedBy;
              delete a.modifiedById;
              delete a.order;
              delete a.triggerId;
            });
          }
        });
      }      
      if (val.lookups) {
        val.lookups.forEach(l => {
          delete l.id;
          delete l.created;
          delete l.modified;
          delete l.modifiedBy;
          delete l.modifiedById;
          delete l.profileId;
        });
      }         
      if (this.profiles.find(x => x.name == val.name)) {
        val.name =
          val.name +
          " (" +
          this.profiles.filter(x => x.name == val.name).length +
          ")";
      }
      this.profiles.push(val);
    },
    removeProfile(id) {
      if (this.profiles.find(x => x.id == id)) {
        this.$http
          .delete("api/organizationprofiles/" + id)
          .then(request => {
            if (request.status == 200) {
              this.getProfiles();
            }
          })
          .catch((e) => {
            this.$root.$children[0].$emit("display-error", "2800", e);
          });
      }
    },
    importProfile() {
      var u = document.createElement("input");
      u.type = "file";
      u.accept = "application/json";
      u.click();
      const self = this;
      u.onchange = function(evt) {
        try {
          let files = evt.target.files;
          if (!files.length) {
            alert("No file selected!");
            return;
          }
          let file = files[0];
          let reader = new FileReader();
          reader.onload = (self => {
            return event => {
              self.parseUploadedProfile(JSON.parse(event.target.result));
            };
          })(self);
          reader.readAsText(file);
        } catch (e) {
            this.$root.$children[0].$emit("display-error", "2801", e);
        }
      };
    },
    exportProfile(id) {
      var profile = this.profiles.find(x => x.id == id);
      var content = JSON.stringify(profile);
      var filename = profile.name + ".json";
      if (content) {
        var a = document.createElement("a");
        var file = new Blob([content], { type: "text/plain" });
        a.href = URL.createObjectURL(file);
        a.download = filename;
        a.click();
      }
    },
    getProfiles() {
      this.selectedProfile = null;
      this.$http
        .get("api/organizationprofiles")
        .then(request => {
          this.profiles = request.data;
        })
        .catch((e) => {
          this.$root.$children[0].$emit("display-error", "2802", e);
        });
    },
    addProfile() {
      this.profiles.push({
        name: "",
        fields: []
      });
      this.selectedProfile = this.profiles[this.profiles.length - 1];
    }
  },
  mounted() {
    this.getProfiles();
  }
};
</script>